import http from '../../../services/http'
import { notify } from '../../../services/notify'
import generalActions from './actionTypes'
import generalMutations from './mutationTypes'

const actions = {
  [generalActions.FETCH_API_VERSION]: async ({ commit }) => {
    const version = process.env.VUE_APP_API_VERSION || null
    if (version) {
      commit(generalMutations.SET_API_VERSION, { response: { data: { version } } })
    }
    return version
  },
  [generalActions.FETCH_FIELD_DEFINITIONS]: async ({ rootState, commit }) => {
    try {
      const response = await http.get('/smartsearch/fields')
      commit(generalMutations.SET_FIELD_DEFINITIONS, response.data)
      return response.data
    } catch {
      return null
    }
  },
  [generalActions.SET_PERMISSIONS]: async ({ commit }, user) => {
    commit(generalMutations.SET_PERMISSIONS, user?.permissions || {})
  },
  [generalActions.TOGGLE_LOADING]: async ({ commit }, loadingState) => {
    commit(generalMutations.SET_LOADING, loadingState)
  },
  [generalActions.TOGGLE_SIDEBAR]: async ({ commit }, navbarState) => {
    commit(generalMutations.SET_SIDEBAR, navbarState)
  },
  [generalActions.TOGGLE_MOBILE_SIDEBAR]: async ({ commit }, navbarState) => {
    commit(generalMutations.SET_MOBILE_SIDEBAR, navbarState)
  },
  [generalActions.SET_GLOBAL_ALERT]: async ({ commit }, alert) => {
    commit(generalMutations.SET_ALERT_MESSAGE, alert)
  },
  [generalActions.LAUNCH_ALERT]: async ({ commit }, options) => {
    notify(options)
  },
  [generalActions.SET_ERROR]: async ({ commit }, error) => {
    commit(generalMutations.SET_ERROR, error)
  },
  [generalActions.CLEAR_ERROR]: async ({ commit }) => {
    commit(generalMutations.CLEAR_ERROR)
  },
  [generalActions.GET_HELP_URL]: async (_) => {
    try {
      const response = await http.get('/help-url')
      return response?.data?.url || ''
    } catch {
      return ''
    }
  },
  [generalActions.SET_HELP_URL]: async ({ commit }, url) => {
    await http.post('/help-url', { url })
  }
}

export default {
  ...actions
}
